import styled from 'styled-components/macro';

export const OkeyBtn = styled.button`
  width: 111px;
  height: 38px;
  background: #11202B;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

    &:disabled {
      opacity: 0.3;
      pointer-events: none;
    }
`;
